require('angular');

const {
    TARGET_PAGE,
    queueDataLayerEvents,
} = require('./analytics/navigationEventQueue');
const {pushDataLayerEvent} = require('./analytics/dataLayer');
const {trackGenerateLead} = require('./analytics/generateLead');
const {getCartContactDetails, getAnalyticsContact} = require('./analytics/contactDetails');

function trackEvent(eventData) {
    return pushDataLayerEvent(eventData, {
        source: 'ecommerce_service',
    });
}

function createPurchaseEvent(ecommerceItems, fbContents, total, currency, shoppingCartId, contactData) {
    return {
        event: 'purchase',
        ...contactData,
        ecommerce: {
            'transaction_id': shoppingCartId,
            'value': total,
            'tax': 0,
            'shipping': 0,
            'currency': currency,
            'items': ecommerceItems,
            'fb-x-contents': fbContents,
            'fb-x-contents-string': JSON.stringify(fbContents)
        }
    };
}

function createAddPaymentInfoEvent(ecommerceItems, fbContents, total, currency, paymentType, coupon) {
    return {
        event: 'add_payment_info',
        ecommerce: {
            'currency': currency,
            'value': total,
            'coupon': coupon,
            'payment_type': paymentType,
            'items': ecommerceItems,
            'fb-x-contents': fbContents,
            'fb-x-contents-string': JSON.stringify(fbContents)
        }
    };
}

function createBeginCheckoutEvent(ecommerceItems, fbContents, total, currency, coupon, contactData) {
    return {
        event: 'begin_checkout',
        ...contactData,
        ecommerce: {
            'value': total,
            'currency': currency,
            'items': ecommerceItems,
            'coupon': coupon,
            'fb-x-contents': fbContents,
            'fb-x-contents-string': JSON.stringify(fbContents)
        }
    };
}

angular.module('app').service('ecommerce', function(){

    this.convertBasketItemsToGA4Ecommerce = function(basketItems) {
        var ordersToSend    = [];
        angular.forEach(basketItems, function(item, key) {
            var priceId = 'price_' + item.api_to_send_order.currency;
            priceId     = priceId.toLowerCase();


            ordersToSend.push({
                'item_id': item.service_id,
                'item_name' : item.service_name,
                'item_variant' : item.private_or_group,
                'item_category' : item.service_type,
                'item_category2' : item.people_quantity,
                'item_category3' : item.api_to_send_order.pick_up_type,
                'item_category4' : item.date,
                'item_category5' : item.language,
                'affiliation' : 'krakowdirect.com',
                'currency' : item.api_to_send_order.currency,
                'discount' : 0,
                'index' : parseInt(key)+1,
                'item_brand' : item.api_to_send_order.channel,
                'quantity' : 1,
                'price' : item[priceId]
            });
        });

        return ordersToSend;
    }

    this.prepareFbPixelContents = function(basketItems) {
        var contents    = [];
        angular.forEach(basketItems, function(item, key) {
            contents.push({
                'id': item.service_id,
                'quantity' : 1
            });
        });

        return contents;
    }

    this.purchase = async function(cart, total, currency, shoppingCartId, contact) {
        let ecommerceItems = this.convertBasketItemsToGA4Ecommerce(cart);
        let fbContents = this.prepareFbPixelContents(cart);
        const contactData = await getAnalyticsContact(contact);
        trackEvent(createPurchaseEvent(ecommerceItems, fbContents, total, currency, shoppingCartId, contactData));

    }

    this.addPaymentInfo = function(cart, total, currency,paymentType, coupon) {
        var ecommerceItems = this.convertBasketItemsToGA4Ecommerce(cart);
        var fbContents = this.prepareFbPixelContents(cart);
        trackEvent(createAddPaymentInfoEvent(ecommerceItems, fbContents, total, currency, paymentType, coupon));

    }

    this.beginCheckout = async function(cart, total, currency, coupon) {
        let ecommerceItems = this.convertBasketItemsToGA4Ecommerce(cart);
        let fbContents = this.prepareFbPixelContents(cart);

        angular.forEach(ecommerceItems, function(item, key) {
            if(!!coupon) item.coupon = coupon;
        });

        const contactData = await getAnalyticsContact(getCartContactDetails(cart));
        trackEvent(createBeginCheckoutEvent(ecommerceItems, fbContents, total, currency, coupon, contactData));
    }

    this.queueBeginCheckout = async function(cart, total, currency, coupon) {
        let ecommerceItems = this.convertBasketItemsToGA4Ecommerce(cart);
        let fbContents = this.prepareFbPixelContents(cart);

        angular.forEach(ecommerceItems, function(item) {
            if (!!coupon) {
                item.coupon = coupon;
            }
        });

        const contactData = await getAnalyticsContact(getCartContactDetails(cart));
        return queueDataLayerEvents(
            createBeginCheckoutEvent(ecommerceItems, fbContents, total, currency, coupon, contactData),
            TARGET_PAGE.CHECKOUT,
            'begin_checkout'
        );
    }

    this.queueOrderCompletion = async function(cart, total, currency, paymentType, coupon, shoppingCartId, contact) {
        const ecommerceItems = this.convertBasketItemsToGA4Ecommerce(cart);
        const fbContents = this.prepareFbPixelContents(cart);
        const contactData = await getAnalyticsContact(contact);

        return queueDataLayerEvents([
            createAddPaymentInfoEvent(ecommerceItems, fbContents, total, currency, paymentType, coupon),
            createPurchaseEvent(ecommerceItems, fbContents, total, currency, shoppingCartId, contactData),
        ], TARGET_PAGE.ORDER_CONFIRMATION, 'order_completion');
    }

    this.removeFromCart = function(cart, total, currency, id) {
        var orders = [];
        angular.forEach(cart, function(item, key){
            if(item.id == id){
                orders.push(item);
            }
        });

        let ecommerceItems = this.convertBasketItemsToGA4Ecommerce(orders);
        let fbContents = this.prepareFbPixelContents(orders);

        trackEvent({
            event:"remove_from_cart",
            ecommerce: {
                'value':            total,
                'currency':         currency,
                'items':            ecommerceItems,
                'fb-x-contents':    fbContents,
                'fb-x-contents-string': JSON.stringify(fbContents)
            }
        });
    }

    this.viewCart = function(cart, total, currency) {
        let ecommerceItems = this.convertBasketItemsToGA4Ecommerce(cart);
        let fbContents = this.prepareFbPixelContents(cart);

        trackEvent({
            event:"view_cart",
            ecommerce: {
                'value':            total,
                'currency':         currency,
                'items':            ecommerceItems,
                'fb-x-contents':    fbContents,
                'fb-x-contents-string': JSON.stringify(fbContents)
            }
        });
    }

    this.generateLead = function(price, currency, email) {
        trackGenerateLead(price, currency, 'ecommerce_service', email);
    };
});
